import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const points = ['Acceso inmediato', '3 bonos incluidos', 'Garantía de 7 días'];
export function FinalCTA() {
  return <section className="relative w-full overflow-hidden bg-coral py-20 text-white sm:py-28" data-id="element-58" data-mp="c83pjkbwtm5j">
      <div className="pointer-events-none absolute -right-20 -top-20 h-80 w-80 rounded-full bg-white/10 blur-2xl" data-id="element-59" data-mp="83vw59uibi0z" />
      <div className="pointer-events-none absolute -bottom-24 -left-16 h-80 w-80 rounded-full bg-plum/20 blur-2xl" data-id="element-60" data-mp="m2voarh8af1w" />

      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="relative mx-auto max-w-3xl px-5 text-center sm:px-6" data-id="element-61" data-mp="vurtsnln97g5">
        <span className="inline-block text-xs font-semibold uppercase tracking-[0.25em] text-white/80" data-id="element-62" data-mp="14vzgs9ipmlux">
          Tu momento es ahora
        </span>
        <h2 className="mt-5 font-display text-3xl font-semibold leading-tight sm:text-5xl" data-id="element-63" data-mp="2c4woipnd6ehx">
          El único riesgo es seguir postergando una oportunidad que podrías empezar a construir hoy
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-white/85" data-id="element-64" data-mp="2m2b3ektn2v84">
          Dá el primer paso hacia tu portfolio, tus servicios y tus primeros USD 1.000 con
          contenido UGC. Con garantía de 7 días.
        </p>

        <div className="mt-9 flex justify-center" data-id="element-65" data-mp="2v4ak1c0qrxaj">
          <CTAButton className="bg-white !text-coral-dark hover:bg-cream hover:!text-coral-dark hover:shadow-[0_24px_60px_-16px_rgba(0,0,0,0.35)]" data-id="element-66" data-mp="2v1g0rntgsiip">
            Empezar ahora con 50% OFF
          </CTAButton>
        </div>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2" data-id="element-67" data-mp="39s5f2z282dqs">
          {points.map(p => <li key={p} className="flex items-center gap-1.5 text-sm text-white/90" data-id="element-68" data-mp="3esb0hxhwf40f">
              <CheckIcon className="h-4 w-4" data-id="element-69" data-mp="3islfu0rkz6ry" />
              {p}
            </li>)}
        </ul>
      </motion.div>
    </section>;
}